export default __webpack_public_path__ + "static/media/Leg_left.36cab71a.svg";